<template>
    <v-row class="ma-n4">
        <v-col class="pa-4" cols="auto" style="width: 140px">
            <v-select
                v-model="query.searchKey"
                v-bind="{
                    ...attrs_input,
                    loading,
                    items: items_searchKey,
                }"
                @input="emit"
            />
        </v-col>
        <v-col class="pa-4" cols="">
            <v-text-field
                v-model="query.searchValue"
                v-bind="{
                    ...attrs_input,
                    loading,
                    appendIcon: focused ? 'mdi-magnify' : undefined,
                }"
                @keydown.enter="emit"
                @focus="focused = true"
                @blur="focused = false"
                @click:append="emit"
            />
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input } from "@/assets/variables";

const items_searchKey = [
    { value: null, text: "전체" },
    { value: "_applicant", text: "아이디" },
    { value: "resume.personalInformation.name", text: "이름" },
    { value: "resume.personalInformation.phone", text: "전화번호" },
    { value: "resume.personalInformation.email", text: "이메일" },
];

const initQuery = (query = {}) => ({
    ...(query || {}),

    searchKey: query.searchKey || null,
    searchValue: query.searchValue || null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),
        focused: false,

        attrs_input,
        items_searchKey,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.searchKey) delete query.searchKey;
            if (!query.searchValue) delete query.searchValue;

            this.$router.push({ query });
        },
        onFocus(...params) {
            console.log(params);
        },
    },
};
</script>

<style lang="scss" scoped></style>
